import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class StickyAddToCart extends Component {
  requiredRefs = ['stickyBar', 'addToCartButton'];
  #observer;
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal });
    document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#onQuantityUpdate, { signal });
    this.#observeProductForm();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
    this.#observer?.disconnect();
  }

  handleAddToCartClick(event) {
    event.preventDefault();

    const form = this.#productForm?.querySelector('form');
    if (!form) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  get #productForm() {
    return document.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
  }

  #observeProductForm() {
    const productForm = this.#productForm;
    if (!productForm) return;

    this.#observer?.disconnect();
    this.#observer = new IntersectionObserver(([entry]) => {
      this.refs.stickyBar.dataset.stuck = entry?.isIntersecting ? 'false' : 'true';
    });
    this.#observer.observe(productForm);
  }

  #onVariantUpdate = (event) => {
    const { data, resource } = event.detail;
    if (data.productId !== this.dataset.productId && data.newProduct?.id !== this.dataset.productId) return;

    const updatedSticky = data.html?.querySelector('sticky-add-to-cart');
    if (updatedSticky) {
      for (const { name, value } of Array.from(updatedSticky.attributes)) {
        if (name.startsWith('data-')) this.setAttribute(name, value);
      }
      this.innerHTML = updatedSticky.innerHTML;
      this.updatedCallback();
      this.#observeProductForm();
      return;
    }

    this.dataset.variantAvailable = String(Boolean(resource?.available));
    this.dataset.currentVariantId = resource?.id ?? '';
    this.refs.addToCartButton.disabled = !resource?.available;
  };

  #onQuantityUpdate = (event) => {
    if (!event.target.closest(`product-form-component[data-product-id="${this.dataset.productId}"]`)) return;

    const quantity = Number(event.detail.quantity) || Number(this.dataset.initialQuantity) || 1;
    const quantityDisplay = this.refs.quantityDisplay;
    const quantityNumber = this.refs.quantityNumber;

    if (quantityDisplay instanceof HTMLElement) {
      quantityDisplay.style.display = quantity > 1 ? 'inline' : 'none';
    }
    if (quantityNumber) {
      quantityNumber.textContent = String(quantity);
    }
  };
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
